// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

export const PayOutApi = createAsyncThunk(
  "AdminPayout/PayOutApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.payout,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const RecruiterPaymentApi = createAsyncThunk(
  "AdminPayout/RecruiterPaymentApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.processforrecruiterpayment,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const ProcessForClientRefundPayment = createAsyncThunk(
  "AdminPayout/ProcessForClientRefundPayment",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.processforreturnpayment,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



const PayOutApiSlice = createSlice({
  name: "PayOutApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PayOutApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(PayOutApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(PayOutApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(RecruiterPaymentApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(RecruiterPaymentApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(RecruiterPaymentApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })


      .addCase(ProcessForClientRefundPayment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(ProcessForClientRefundPayment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(ProcessForClientRefundPayment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
  },
});
export default PayOutApiSlice.reducer;
